import React, { useState, memo } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/Tabs';
import { Search, Filter, Plus, MoreHorizontal, Building, Mail, Phone, ChevronDown } from 'lucide-react';
interface PeopleProps {
  userRole: 'Program Manager' | 'Founder';
}
const People: React.FC<PeopleProps> = ({
  userRole
}) => {
  const [activeTab, setActiveTab] = useState('all');
  const [selectedVenture, setSelectedVenture] = useState('CardioSense');
  return <div className="w-full px-6 pt-6" data-id="element-842">
      <div className="flex justify-between items-center mb-6" data-id="element-843">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-844">People Network</h1>
        <div className="flex items-center space-x-3" data-id="element-845">
          <div className="relative" data-id="element-846">
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-md flex items-center text-sm text-gray-700" data-id="element-847">
              <span className="mr-2" data-id="element-848">Venture:</span>
              {selectedVenture}
              <ChevronDown size={14} className="ml-2 text-gray-500" data-id="element-849" />
            </button>
          </div>
          <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md flex items-center transition-colors" data-id="element-850">
            <Plus size={16} className="mr-2" data-id="element-851" />
            Add Person
          </button>
        </div>
      </div>
      {/* Search and Filter */}
      <div className="flex justify-between mb-6" data-id="element-852">
        <div className="relative w-64" data-id="element-853">
          <input type="text" placeholder="Search people..." className="w-full pl-10 pr-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-854" />
          <Search className="absolute left-3 top-2.5 text-gray-400" size={18} data-id="element-855" />
        </div>
        <div className="flex space-x-3" data-id="element-856">
          <div className="relative" data-id="element-857">
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-md flex items-center text-sm text-gray-700" data-id="element-858">
              <Filter size={14} className="mr-2 text-gray-500" data-id="element-859" />
              Filter
              <ChevronDown size={14} className="ml-2 text-gray-500" data-id="element-860" />
            </button>
          </div>
          <div className="relative" data-id="element-861">
            <button className="px-4 py-2 bg-white border border-gray-300 rounded-md flex items-center text-sm text-gray-700" data-id="element-862">
              Sort: Recently Added
              <ChevronDown size={14} className="ml-2 text-gray-500" data-id="element-863" />
            </button>
          </div>
        </div>
      </div>
      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full" data-id="element-864">
        <TabsList className="mb-6" data-id="element-865">
          <TabsTrigger value="all" data-id="element-866">All</TabsTrigger>
          <TabsTrigger value="builders" data-id="element-867">Builders</TabsTrigger>
          <TabsTrigger value="investors" data-id="element-868">Investors</TabsTrigger>
          <TabsTrigger value="advisors" data-id="element-869">Advisors</TabsTrigger>
          <TabsTrigger value="mentors" data-id="element-870">Mentors</TabsTrigger>
          <TabsTrigger value="prospects" data-id="element-871">Prospects</TabsTrigger>
          <TabsTrigger value="customers" data-id="element-872">Customers</TabsTrigger>
          <TabsTrigger value="stakeholders" data-id="element-873">Stakeholders</TabsTrigger>
        </TabsList>
        <TabsContent value="all" className="space-y-4" data-id="element-874">
          {/* People Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-875">
            {/* Person Card */}
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-876">
              <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-877">
                <div className="flex items-center" data-id="element-878">
                  <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mr-3" data-id="element-879">
                    DR
                  </div>
                  <div data-id="element-880">
                    <h3 className="font-medium text-gray-800" data-id="element-881">
                      Dr. Rachel Chen
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-882">
                      Last contacted: 2 weeks ago
                    </p>
                  </div>
                </div>
                <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-883">
                  <MoreHorizontal size={16} className="text-gray-500" data-id="element-884" />
                </button>
              </div>
              <div className="p-4" data-id="element-885">
                <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-886">
                  <Building size={14} className="mr-2" data-id="element-887" />
                  <span data-id="element-888">Memorial Healthcare - Cardiac Rehab Director</span>
                </div>
                <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-889">
                  <Mail size={14} className="mr-2" data-id="element-890" />
                  <span data-id="element-891">r.chen@memorialhc.org</span>
                </div>
                <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-892">
                  <Phone size={14} className="mr-2" data-id="element-893" />
                  <span data-id="element-894">(555) 123-4567</span>
                </div>
                <div className="flex space-x-2 mb-3" data-id="element-895">
                  <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full" data-id="element-896">
                    Stakeholder
                  </span>
                  <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-897">
                    Customer
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-3" data-id="element-898">
                  Key decision-maker for cardiac rehab program. Interested in
                  improving patient adherence metrics.
                </p>
                <div className="flex space-x-2" data-id="element-899">
                  <button className="px-3 py-1.5 text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-900">
                    View Profile
                  </button>
                  <button className="px-3 py-1.5 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-901">
                    Add Interaction
                  </button>
                </div>
              </div>
            </div>
            {/* Person Card */}
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-902">
              <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-903">
                <div className="flex items-center" data-id="element-904">
                  <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600 mr-3" data-id="element-905">
                    JL
                  </div>
                  <div data-id="element-906">
                    <h3 className="font-medium text-gray-800" data-id="element-907">James Lee</h3>
                    <p className="text-xs text-gray-500" data-id="element-908">
                      Last contacted: 3 days ago
                    </p>
                  </div>
                </div>
                <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-909">
                  <MoreHorizontal size={16} className="text-gray-500" data-id="element-910" />
                </button>
              </div>
              <div className="p-4" data-id="element-911">
                <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-912">
                  <Building size={14} className="mr-2" data-id="element-913" />
                  <span data-id="element-914">HealthVentures Capital - Managing Partner</span>
                </div>
                <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-915">
                  <Mail size={14} className="mr-2" data-id="element-916" />
                  <span data-id="element-917">james@healthventures.com</span>
                </div>
                <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-918">
                  <Phone size={14} className="mr-2" data-id="element-919" />
                  <span data-id="element-920">(555) 987-6543</span>
                </div>
                <div className="flex space-x-2 mb-3" data-id="element-921">
                  <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full" data-id="element-922">
                    Investor
                  </span>
                  <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full" data-id="element-923">
                    Advisor
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-3" data-id="element-924">
                  Early-stage healthcare investor. Previously founded MedTech
                  startup. Expertise in reimbursement models.
                </p>
                <div className="flex space-x-2" data-id="element-925">
                  <button className="px-3 py-1.5 text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-926">
                    View Profile
                  </button>
                  <button className="px-3 py-1.5 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-927">
                    Add Interaction
                  </button>
                </div>
              </div>
            </div>
            {/* Person Card */}
            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-928">
              <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-929">
                <div className="flex items-center" data-id="element-930">
                  <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 mr-3" data-id="element-931">
                    SM
                  </div>
                  <div data-id="element-932">
                    <h3 className="font-medium text-gray-800" data-id="element-933">
                      Sarah Martinez
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-934">
                      Last contacted: 1 week ago
                    </p>
                  </div>
                </div>
                <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-935">
                  <MoreHorizontal size={16} className="text-gray-500" data-id="element-936" />
                </button>
              </div>
              <div className="p-4" data-id="element-937">
                <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-938">
                  <Building size={14} className="mr-2" data-id="element-939" />
                  <span data-id="element-940">CardiacTech - Former CTO</span>
                </div>
                <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-941">
                  <Mail size={14} className="mr-2" data-id="element-942" />
                  <span data-id="element-943">sarah@healthmentor.io</span>
                </div>
                <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-944">
                  <Phone size={14} className="mr-2" data-id="element-945" />
                  <span data-id="element-946">(555) 456-7890</span>
                </div>
                <div className="flex space-x-2 mb-3" data-id="element-947">
                  <span className="px-2 py-1 bg-indigo-100 text-indigo-800 text-xs rounded-full" data-id="element-948">
                    Mentor
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-3" data-id="element-949">
                  15+ years in healthcare technology. Expert in remote
                  monitoring and patient engagement solutions.
                </p>
                <div className="flex space-x-2" data-id="element-950">
                  <button className="px-3 py-1.5 text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-951">
                    View Profile
                  </button>
                  <button className="px-3 py-1.5 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-952">
                    Add Interaction
                  </button>
                </div>
              </div>
            </div>
          </div>
        </TabsContent>
        <TabsContent value="investors" data-id="element-953">
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-954">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-955">
              <div className="flex items-center" data-id="element-956">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600 mr-3" data-id="element-957">
                  JL
                </div>
                <div data-id="element-958">
                  <h3 className="font-medium text-gray-800" data-id="element-959">James Lee</h3>
                  <p className="text-xs text-gray-500" data-id="element-960">
                    Last contacted: 3 days ago
                  </p>
                </div>
              </div>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-961">
                <MoreHorizontal size={16} className="text-gray-500" data-id="element-962" />
              </button>
            </div>
            <div className="p-4" data-id="element-963">
              <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-964">
                <Building size={14} className="mr-2" data-id="element-965" />
                <span data-id="element-966">HealthVentures Capital - Managing Partner</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-967">
                <Mail size={14} className="mr-2" data-id="element-968" />
                <span data-id="element-969">james@healthventures.com</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-970">
                <Phone size={14} className="mr-2" data-id="element-971" />
                <span data-id="element-972">(555) 987-6543</span>
              </div>
              <div className="flex space-x-2 mb-3" data-id="element-973">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full" data-id="element-974">
                  Investor
                </span>
                <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full" data-id="element-975">
                  Advisor
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-3" data-id="element-976">
                Early-stage healthcare investor. Previously founded MedTech
                startup. Expertise in reimbursement models.
              </p>
              <div className="flex space-x-2" data-id="element-977">
                <button className="px-3 py-1.5 text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-978">
                  View Profile
                </button>
                <button className="px-3 py-1.5 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-979">
                  Add Interaction
                </button>
              </div>
            </div>
          </div>
        </TabsContent>
        {/* Other tab contents would be similar */}
        <TabsContent value="advisors" data-id="element-980">
          <div className="text-center py-10 text-gray-500" data-id="element-981">
            <p data-id="element-982">No advisors added yet</p>
          </div>
        </TabsContent>
        <TabsContent value="mentors" data-id="element-983">
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-984">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-985">
              <div className="flex items-center" data-id="element-986">
                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 mr-3" data-id="element-987">
                  SM
                </div>
                <div data-id="element-988">
                  <h3 className="font-medium text-gray-800" data-id="element-989">Sarah Martinez</h3>
                  <p className="text-xs text-gray-500" data-id="element-990">
                    Last contacted: 1 week ago
                  </p>
                </div>
              </div>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-991">
                <MoreHorizontal size={16} className="text-gray-500" data-id="element-992" />
              </button>
            </div>
            <div className="p-4" data-id="element-993">
              <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-994">
                <Building size={14} className="mr-2" data-id="element-995" />
                <span data-id="element-996">CardiacTech - Former CTO</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-997">
                <Mail size={14} className="mr-2" data-id="element-998" />
                <span data-id="element-999">sarah@healthmentor.io</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-1000">
                <Phone size={14} className="mr-2" data-id="element-1001" />
                <span data-id="element-1002">(555) 456-7890</span>
              </div>
              <div className="flex space-x-2 mb-3" data-id="element-1003">
                <span className="px-2 py-1 bg-indigo-100 text-indigo-800 text-xs rounded-full" data-id="element-1004">
                  Mentor
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-3" data-id="element-1005">
                15+ years in healthcare technology. Expert in remote monitoring
                and patient engagement solutions.
              </p>
              <div className="flex space-x-2" data-id="element-1006">
                <button className="px-3 py-1.5 text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-1007">
                  View Profile
                </button>
                <button className="px-3 py-1.5 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-1008">
                  Add Interaction
                </button>
              </div>
            </div>
          </div>
        </TabsContent>
        <TabsContent value="prospects" data-id="element-1009">
          <div className="text-center py-10 text-gray-500" data-id="element-1010">
            <p data-id="element-1011">No prospects added yet</p>
          </div>
        </TabsContent>
        <TabsContent value="customers" data-id="element-1012">
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-1013">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1014">
              <div className="flex items-center" data-id="element-1015">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mr-3" data-id="element-1016">
                  DR
                </div>
                <div data-id="element-1017">
                  <h3 className="font-medium text-gray-800" data-id="element-1018">Dr. Rachel Chen</h3>
                  <p className="text-xs text-gray-500" data-id="element-1019">
                    Last contacted: 2 weeks ago
                  </p>
                </div>
              </div>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-1020">
                <MoreHorizontal size={16} className="text-gray-500" data-id="element-1021" />
              </button>
            </div>
            <div className="p-4" data-id="element-1022">
              <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-1023">
                <Building size={14} className="mr-2" data-id="element-1024" />
                <span data-id="element-1025">Memorial Healthcare - Cardiac Rehab Director</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-1026">
                <Mail size={14} className="mr-2" data-id="element-1027" />
                <span data-id="element-1028">r.chen@memorialhc.org</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-1029">
                <Phone size={14} className="mr-2" data-id="element-1030" />
                <span data-id="element-1031">(555) 123-4567</span>
              </div>
              <div className="flex space-x-2 mb-3" data-id="element-1032">
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full" data-id="element-1033">
                  Stakeholder
                </span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-1034">
                  Customer
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-3" data-id="element-1035">
                Key decision-maker for cardiac rehab program. Interested in
                improving patient adherence metrics.
              </p>
              <div className="flex space-x-2" data-id="element-1036">
                <button className="px-3 py-1.5 text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-1037">
                  View Profile
                </button>
                <button className="px-3 py-1.5 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-1038">
                  Add Interaction
                </button>
              </div>
            </div>
          </div>
        </TabsContent>
        <TabsContent value="stakeholders" data-id="element-1039">
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm" data-id="element-1040">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1041">
              <div className="flex items-center" data-id="element-1042">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mr-3" data-id="element-1043">
                  DR
                </div>
                <div data-id="element-1044">
                  <h3 className="font-medium text-gray-800" data-id="element-1045">Dr. Rachel Chen</h3>
                  <p className="text-xs text-gray-500" data-id="element-1046">
                    Last contacted: 2 weeks ago
                  </p>
                </div>
              </div>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-1047">
                <MoreHorizontal size={16} className="text-gray-500" data-id="element-1048" />
              </button>
            </div>
            <div className="p-4" data-id="element-1049">
              <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-1050">
                <Building size={14} className="mr-2" data-id="element-1051" />
                <span data-id="element-1052">Memorial Healthcare - Cardiac Rehab Director</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mb-2" data-id="element-1053">
                <Mail size={14} className="mr-2" data-id="element-1054" />
                <span data-id="element-1055">r.chen@memorialhc.org</span>
              </div>
              <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-1056">
                <Phone size={14} className="mr-2" data-id="element-1057" />
                <span data-id="element-1058">(555) 123-4567</span>
              </div>
              <div className="flex space-x-2 mb-3" data-id="element-1059">
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full" data-id="element-1060">
                  Stakeholder
                </span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full" data-id="element-1061">
                  Customer
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-3" data-id="element-1062">
                Key decision-maker for cardiac rehab program. Interested in
                improving patient adherence metrics.
              </p>
              <div className="flex space-x-2" data-id="element-1063">
                <button className="px-3 py-1.5 text-xs bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors" data-id="element-1064">
                  View Profile
                </button>
                <button className="px-3 py-1.5 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors" data-id="element-1065">
                  Add Interaction
                </button>
              </div>
            </div>
          </div>
        </TabsContent>
      </Tabs>
    </div>;
};
export default People;